import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card } from 'material-ui/Card';
import * as actions from './../../data/settings/actions';
import MainCardContainer from '../../components/MainCardContainer/';
import {
  BID_TYPES,
  CATEGORY_ID,
  httpStatus,
  LANGUAGE,
  LOADSTANDING_KEY,
  LVBSID,
  STAFFID,
  STDBIDSESSION_ID
} from './../../data/constants/';
import Loader from './../../components/Loader';
import { getDateStr } from './../../utilities/helpers';
import Language from './components/Language';
import Weight from './components/Weight';
import CardRow from './../../components/CardRow';
import * as actionsBidSession from './../../data/bidSession/actions';
import CardHead from '../../components/CardHead';
import { useLanguage } from '../../context/LanguageContext';

const Settings = props => {
  const { labels } = useLanguage();
  const commonLabels = labels.commonLabels || {};
  const SETTINGS = labels.SETTINGS || {};

  const [lastSave, setLastSave] = useState(null);
  const [profileLastSave, setProfileLastSave] = useState(null);
  const [bidPreferences, setBidPreferences] = useState({ entries: [] });
  const [preferenceAdded, setPreferenceAdded] = useState(false);
  const [bidmode, setBidmode] = useState('');
  const [openbid, setOpenbid] = useState([]);
  const [checked, setChecked] = useState(false);
  const [lang, setLang] = useState(LANGUAGE.DEFAULT_LANG);

  const bidSession = {
    currentBid: {
      bidSessionId: sessionStorage.getItem(LVBSID)
    },
    user: {}
  };
  
  useEffect(() => {
    const staffId = parseInt(sessionStorage.getItem(STAFFID));
    const standingBidSessionId = parseInt(sessionStorage.getItem(LVBSID));
    const categoryId = sessionStorage.getItem(CATEGORY_ID);
    const { fetchSettings, openbid, getUserInfo } = props;

    fetchSettings(staffId, standingBidSessionId);

    openbid(categoryId).then(response => setOpenbid(response.data.entries));

    const lang = sessionStorage.getItem(LANGUAGE.LANG_KEY);
    if (lang) {
      setLang(lang === LANGUAGE.DEFAULT_LANG ? 1 : 2 );
    }

    const checked = JSON.parse(sessionStorage.getItem(LOADSTANDING_KEY));
    setChecked(checked);

    getUserInfo(staffId).then(response => {
      setProfileLastSave(response.data.profileLastSave);
      setChecked(response.data.loadStanding);
      actions.reloadSessionStorageUserInfo(response.data);
    });
  }, []);

  const handleSaveUserInfo = (staffid, lang, checkValue) => {
    const staffId = staffid;
    const locale = lang;
    const checked = checkValue;
    props.saveUserInfo(checked, locale, staffId);
  };

  const handleDefaultBidCheckboxChange = async event => {
    const checked = event.target.checked;
    setChecked(checked);
    sessionStorage.setItem(LOADSTANDING_KEY, JSON.stringify(checked));
    const langKey = sessionStorage.getItem(LANGUAGE.LANG_KEY);

    try {
      await props.saveUserInfo(checked, langKey, props.user.staffId);
    } catch (err) {
      console.error('Failed to save user info', err);
    }

  };

  const handleBidMode = (bidMode, defaultvalue) => {
    const lastViewedBidSessionId = sessionStorage.getItem('islastViewedDefault')==="true" ? sessionStorage.getItem(STDBIDSESSION_ID) : sessionStorage.getItem(LVBSID);
    const bidPreference = {
      bidSessionId: lastViewedBidSessionId,
      staffId: props.user.staffId,
      employeeBidId: 0,
      bidAggregateId: 0,
      bidSessionSnapshotId: 0,
      preferenceOptionId: 0,
      preferenceOptionPropertyId: 0,
      score: defaultvalue
    };
    props.updateBidSessionBidMode(bidPreference, bidMode);
    props.updateAllWeightMode(bidPreference, bidMode).catch(error=> {
      console.log(error)
    });
  };


  const { isSettingsFetching, settings } = props;
  const defaultBidCheckboxTitle = (
    <div>
      {SETTINGS.LOAD_DEFAULT_BIDS} &nbsp;{' '}
      <input
        type={'checkbox'}
        checked={checked}
        onChange={handleDefaultBidCheckboxChange}
      />
    </div>
  );

  const renderWeigth = (
    sessionStorage.getItem('bidmode') === commonLabels.PRIORITY || 
    sessionStorage.getItem('bidmode') === commonLabels.NONE
  ) ? false : true;

  return (
    <div>
      {isSettingsFetching ? (
        <Loader />
      ) : (
        <MainCardContainer
          headTitle={SETTINGS.PAGE_TITLE}
          headSubtitle={`${SETTINGS.LAST_SAVED} ${getDateStr(
            profileLastSave
          )}`}
          content={[
            <CardRow
              key={1}
              cardNumber={1}
              cards={[
                <Language
                  handleSaveLanguage={handleSaveUserInfo}
                  staffId={props.user.staffId}
                />
              ]}
            />,
            props.user.staffId !== commonLabels.ADMIN ? (
              <CardRow
                key={2}
                cardNumber={1}
                cards={[
                  <Card>
                    <div>
                      <CardHead
                        title={defaultBidCheckboxTitle}
                        headClassName='Open-Search-Head'
                        titleStyle={{ fontSize: '1rem' }}
                      />
                    </div>
                  </Card>
                ]}
              />
            ) : (
              ''
            ),

            renderWeigth && <CardRow
              key={3}
              cardNumber={1}
              cards={[<Weight handleBidMode={handleBidMode} />]}
            />
          ]}
        />
      )}
    </div>
  );
}


Settings.defaultProps = {
  isSettingsFetching: false,
  settings: {},
  user: {},
  error: {},
  fetchSettings: () => {},
  getLanguage: () => {},
  saveUserInfo: () => {},
  switchPriority: () => {},
  updateScore: () => {},
  updateWeight: () => {},
  updateWeightMode: () => {},
  updateAllWeightMode: () => {},
  updateBidSessionBidMode: () => {},
  getUserInfo: () => {},
  openbid: () => {}
};

Settings.propTypes = {
  isSettingsFetching: PropTypes.bool,
  settings: PropTypes.object,
  user: PropTypes.object,
  fetchSettings: PropTypes.func,
  getLanguage: PropTypes.func,
  getUserInfo: PropTypes.func,
  saveUserInfo: PropTypes.func,
  switchPriority: PropTypes.func,
  updateScore: PropTypes.func,
  updateWeightMode: PropTypes.func,
  updateAllWeightMode: PropTypes.func,
  updateBidSessionBidMode: PropTypes.func,
  updateWeight: PropTypes.func,
  openbid: PropTypes.func
};

const mapStateToProps = state => ({ ...state.settings, ...state.login });

const mapDispatchToProps = dispatch => ({
  fetchSettings: (staffId, standingBidSessionId) =>
    dispatch(actions.fetchSettings(staffId, standingBidSessionId)),
  switchPriority: (type, oldScore, bidSession) =>
    dispatch(
      actionsBidSession.default.switchPriority(type, oldScore, bidSession)
    ),
  updateScore: (preference, newScore) =>
    dispatch(actionsBidSession.default.updateScore(preference, newScore)),
  getLanguage: staffId => dispatch(actions.getLanguage(staffId)),
  getUserInfo: staffId => dispatch(actions.getUserInfo(staffId)),
  saveUserInfo: (checked, locale, staffid) =>
    dispatch(actions.saveUserInfo(checked, locale, staffid)),
  openbid: categoryId => dispatch(actions.openbid(categoryId)),
  updateWeightMode: (preference, bidMode) =>
        dispatch(actions.updateWeightMode(preference, bidMode)),
  updateAllWeightMode: (preference, bidMode) =>
    dispatch(actions.updateAllWeightMode(preference, bidMode)),
  updateBidSessionBidMode: (preference, bidMode) =>
     dispatch(actions.updateBidSessionBidMode(preference, bidMode)),
  updateWeight: (preference, newScore, bidMode) =>
    dispatch(actions.updateWeight(preference, newScore, bidMode))
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
